var _rect, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWorkPassport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    role: "img",
    "aria-label": "Work Passport",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 5.5,
    width: 25,
    height: 21,
    rx: 3,
    fill: "none",
    stroke: "#FF2775",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 13,
    r: 3,
    fill: "none",
    stroke: "#FF2775",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 21.5c.6-3.2 2-4.8 4-4.8s3.4 1.6 4 4.8M17.5 11h7M17.5 15h4.5",
    fill: "none",
    stroke: "#FF2775",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m18 21 2.1 2 4.3-5",
    fill: "none",
    stroke: "#FF2775",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWorkPassport);
export default __webpack_public_path__ + "static/media/icon-work-passport.4e3f55ef8c5733d530a1b090aa2e82c9.svg";
export { ForwardRef as ReactComponent };